import React from 'react';
import PropTypes from 'prop-types';
import Offcanvas from 'react-bootstrap/Offcanvas';

/**
 * The record drawer (detail-page spec §5) — a 560px right-side panel.
 * Built on react-bootstrap `Offcanvas`, which supplies backdrop, Escape,
 * body scroll-lock and focus containment for free (see SettingsLayout.jsx
 * for the only other Offcanvas in the app, styled the same way: override via
 * CSS rather than reimplementing the shell).
 */
function RecordDrawer({ show, onClose, meta, title, children, footer }) {
	return (
		<Offcanvas
			show={show}
			onHide={onClose}
			placement='end'
			className='entity-list-page tw:w-[560px] tw:max-w-[100vw]'
		>
			<Offcanvas.Header closeButton className='tw:border-b tw:border-border tw:px-[22px] tw:py-[18px]'>
				<div>
					{meta && <div className='tw:mb-1 tw:text-[12px] tw:text-ink-3'>{meta}</div>}
					<Offcanvas.Title className='tw:text-[18px] tw:font-bold tw:tracking-[-0.015em] tw:text-ink-0'>
						{title}
					</Offcanvas.Title>
				</div>
			</Offcanvas.Header>
			<Offcanvas.Body className='tw:flex tw:flex-col tw:gap-[22px] tw:p-[22px]'>{children}</Offcanvas.Body>
			{footer && (
				<div className='tw:flex tw:justify-end tw:gap-2 tw:border-t tw:border-border tw:bg-surface-2 tw:px-[22px] tw:py-3.5'>
					{footer}
				</div>
			)}
		</Offcanvas>
	);
}

RecordDrawer.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	meta: PropTypes.node,
	title: PropTypes.node,
	children: PropTypes.node,
	footer: PropTypes.node,
};

export default RecordDrawer;
